import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface InstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: string }>;
}
export default function PwaInstall() {
  const { t } = useTranslation();
  const [prompt, setPrompt] = useState<InstallPrompt>();
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const capture = (event: Event) => {
      event.preventDefault();
      setPrompt(event as InstallPrompt);
    };
    const installed = () => setPrompt(undefined);
    window.addEventListener("beforeinstallprompt", capture);
    window.addEventListener("appinstalled", installed);
    return () => {
      window.removeEventListener("beforeinstallprompt", capture);
      window.removeEventListener("appinstalled", installed);
    };
  }, []);
  if (
    !prompt ||
    dismissed ||
    window.matchMedia("(display-mode: standalone)").matches
  )
    return null;
  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex gap-2 rounded-lg border bg-white p-2 shadow-lg"
      aria-label={t("pwa_install")}
    >
      <Button
        size="sm"
        onClick={async () => {
          await prompt.prompt();
          await prompt.userChoice;
          setPrompt(undefined);
        }}
      >
        {t("pwa_install")}
      </Button>
      <Button size="sm" variant="ghost" onClick={() => setDismissed(true)}>
        {t("pwa_later")}
      </Button>
    </div>
  );
}
